import { createSignal } from "solid-js";

export interface UseCopyOptions {
  richText?: boolean;
  timeout?: number;
}

export function useCopy(options: UseCopyOptions = {}) {
  const [copied, setCopied] = createSignal(false);
  const { richText = false, timeout = 1500 } = options;

  const copy = async (value: string) => {
    try {
      if (richText && navigator.clipboard.write) {
        const html = `<pre><code>${escapeHtml(value)}</code></pre>`;
        await navigator.clipboard.write([
          new window.ClipboardItem({
            "text/plain": new Blob([value], { type: "text/plain" }),
            "text/html": new Blob([html], { type: "text/html" }),
          }),
        ]);
      } else {
        await navigator.clipboard.writeText(value);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), timeout);
      return true;
    } catch {
      return false;
    }
  };

  return { copied, copy };
}

// Simple HTML escape for <, >, &
function escapeHtml(str: string) {
  return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
